export const VocabConfirmEmail = {
    'verify_success_tittle' : ['Correo verificado!', 'Email verified!'],
    'verify_success_message' : ['Ahora puedes iniciar sesión.', 'You can now log in.'],
    'verifying' : ['Verificando...', 'Verifying...'],
    'go_to_login' : ['Ir al inicio de sesion', 'Go to login'],
    'go_to_dashboard' : ['Inicio', 'Go to dashboard'],
    'verify_failed_tittle' : ['Verificación fallida', 'Verification failed'],
  }
    